import { Card, CircularProgress, createTheme, IconButton, withStyles } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React, { Component } from 'react';
import { BLUE } from '../../../_config/consts';
import KeyOutlinedIconCustom from '../../CustomIcons/KeyOutlinedIconCustom.jsx';


const styles = theme => ({
  titleText: {
    margin: 0,
    color: '#3f3f3f',
    marginLeft: 10,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    margin: 5,
    borderRadius: 10,
    justifyContent: 'center',
  },
  icon: {
    width: 30,
    color: '#3f3f3f',
  },
  countText: {
    color: '#3f3f3f',
    margin: 0,
    fontSize: 35,
  },
  progress: {
    margin: 0,
    marginTop: 0,
    padding: 0,
    height: '38px !important',
    width: '38px !important',
  },
  chartsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  refreshButton: {
    position: 'absolute',
    right: 5,
    top: -5,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  refreshIcon: {
    fontSize: 20,
    color: '#3f3f3f',
  },
  separator: {
    margin: 10,
    marginBottom: 0,
    height: 2,
  },
  linkText: {
    textAlign: 'center',
    paddingTop: 12,
    margin: 0,
    paddingBottom: 4,
    width: '100%',
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

class HyperKeysMetricChart extends Component {
  render() {
    const { metric: { count }, isRefreshing, classes, onRefreshMetric, onShortcutClick, onMetricClick } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <Card elevation={3} className={classes.container}>
          <div style={{ cursor: 'pointer' }} onClick={onMetricClick ? () => onMetricClick('/hyperKeys') : null}>
            <div className={classes.header}>
              <div className={classes.titleContainer}>
                <KeyOutlinedIconCustom className={classes.icon} />
                <h3 className={classes.titleText}><Entity entity="mechatronicsKey" /></h3>
              </div>
              <IconButton
                style={{ opacity: isRefreshing ? 0.5 : 1 }}
                disabled={isRefreshing}
                className={classes.refreshButton}
                onClick={(e) => { e.stopPropagation(); onRefreshMetric('hyperKeys'); }}
              >
                <RefreshIcon className={classes.refreshIcon} />
              </IconButton>
            </div>
            <div className={classes.chartsContainer}>
              {isRefreshing ? <CircularProgress color="primary" className={classes.progress} /> : <h1 className={classes.countText}>{count}</h1>}
            </div>
          </div>
          <hr className={classes.separator} />
          <h4 className={`link-label ${classes.linkText}`} style={{ fontWeight: 'bold' }} onClick={() => onShortcutClick()}><Entity entity="addHyperKeys" /></h4>
        </Card>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(HyperKeysMetricChart);
